import React, { useState } from 'react';
import { PopupButton } from 'react-calendly';
import { CONTACT_US_CALENDLY_URL } from '../../../../utils/constant/constants';
import { GoArrowLeft, GoArrowRight } from 'react-icons/go';
import package1 from '../../../../assets/marketing/DrawingRoom.webp';
import { featureIcons } from '../constants';
import FeatureItem from './FeatureItem';

const PremierPackage = () => {
	const [showFullContent1, setShowFullContent1] = useState(false);

	return (
		<div
			id='premier-package'
			className='md:mr-[20px] w-full max-w-[487px] relative'>
			{/* Mobile-only header */}
			<div className='md:hidden text-center mb-4'>
				<h4 className='font-canela-trial text-[20px] font-medium uppercase text-clientWhite'>
					For Individual Agents
				</h4>
			</div>

			<div className='bg-[#2A2A2A] rounded-t-[13px] border-t-4 border-[rgba(204,_29,_185,_0.7)]'>
				<img
					src={package1}
					alt='Premier Package'
					loading='lazy'
					className='w-full max-w-[487px] h-auto sm:h-auto h-[180px] rounded-t-[13px] rounded-b-none object-cover m-[0] md:mt-[-260px]'
				/>
				<div className='px-6 sm:px-6 px-4 py-4 flex flex-col h-full'>
					<div className='mt-[20px] w-full'>
						<p className='font-lejour text-[clamp(16px,_3vw,_22px)] font-normal leading-[34.2px] sm:leading-[34.2px] leading-[28px] uppercase m-0 text-clientWhite'>
							The Premier Package
							<span className='block font-glacial text-[clamp(16px,_3vw,_22px)] font-bold leading-[24.2px] m-0 text-[rgba(204,_29,_185,_0.9)]'>
								$1095
								<span className='font-bold text-clientWhite'>/month</span>
							</span>
						</p>
					</div>

					<div className='flex-grow mb-[10px] mt-[20px] h-auto w-full text-[#CFCFCF]'>
						<p className='mb-[20px] font-glacial text-[18px] sm:text-[18px] text-[16px] font-normal leading-[25.2px] sm:leading-[25.2px] leading-[22px] text-[#CFCFCF]'>
							Designed for real estate professionals seeking expert marketing
							support to grow their business.
						</p>

						<FeatureItem
							icon={featureIcons.business}
							text='Business consultation & strategic growth planning'
						/>
						<FeatureItem
							icon={featureIcons.design}
							text='Custom marketing design & execution'
						/>

						<div>
							{showFullContent1 ? (
								<React.Fragment>
									<FeatureItem
										icon={featureIcons.email}
										text='Email marketing campaigns that engage & convert'
									/>
									<FeatureItem
										icon={featureIcons.social}
										text='Targeted social media marketing'
									/>
									<FeatureItem
										icon={featureIcons.mail}
										text='Direct mail campaigns'
									/>
									<FeatureItem
										icon={featureIcons.ads}
										text='Digital advertising management'
									/>
									<FeatureItem
										icon={featureIcons.listing}
										text='Listing marketing, including:'
									/>

									<FeatureItem
										icon={featureIcons.check}
										text='Professionally designed listing flyers & social media posts'
										indent={true}
									/>
									<FeatureItem
										icon={featureIcons.check}
										text='Targeted listing ads'
										indent={true}
									/>
									<FeatureItem
										icon={featureIcons.check}
										text='Personalized client letters'
										indent={true}
									/>
									<FeatureItem
										icon={featureIcons.check}
										text='Property listing websites & marketing collateral'
										indent={true}
									/>

									<FeatureItem
										icon={featureIcons.clients}
										text='Post-close marketing to maintain client relationships:'
									/>

									<FeatureItem
										icon={featureIcons.check}
										text='Social media engagement'
										indent={true}
									/>
									<FeatureItem
										icon={featureIcons.check}
										text='Follow-up client letters'
										indent={true}
									/>
									<FeatureItem
										icon={featureIcons.check}
										text='Review request strategies'
										indent={true}
									/>
									<FeatureItem
										icon={featureIcons.check}
										text='Personalized client follow-ups'
										indent={true}
									/>
									<FeatureItem
										icon={featureIcons.check}
										text='CRM management & optimization'
										indent={true}
									/>

									<FeatureItem
										icon={featureIcons.more}
										text='Additional custom design work & more'
									/>
								</React.Fragment>
							) : (
								''
							)}
						</div>

						<button
							type='button'
							onClick={() => setShowFullContent1(!showFullContent1)}
							className='flex items-center font-bold mt-[20px] text-clientWhite text-[14px] leading-[16.8px] cursor-pointer hover:text-[rgba(204,_29,_185,_0.8)] transition-colors'>
							{showFullContent1 ? 'VIEW LESS DETAILS' : 'VIEW ALL DETAILS'}

							{showFullContent1 ? (
								<GoArrowLeft className='text-[rgba(204,_29,_185,_0.8)] text-[20px] ml-2 mb-[2px]' />
							) : (
								<GoArrowRight className='text-[rgba(204,_29,_185,_0.8)] text-[20px] ml-2 mb-[2px]' />
							)}
						</button>

						<div className='mt-auto pt-6 flex justify-center'>
							<PopupButton
								className='font-glacial my-[18px] bg-[rgba(204,_29,_185,_0.8)] hover:bg-[rgba(204,_29,_185,_0.7)] transition-colors rounded-[6px] mb-[50px] h-[60px] sm:h-[60px] h-[50px] w-full text-[18px] sm:text-[18px] text-[16px] smallView:text-[15px] font-bold leading-[28px] text-clientWhite cursor-pointer'
								url={CONTACT_US_CALENDLY_URL}
								rootElement={document.getElementById('root')}
								text='Get Started with Premier Package'
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PremierPackage;
